"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryType = void 0;
var StoryType;
(function (StoryType) {
    StoryType["UNKNOWN"] = "UNKNOWN";
    StoryType["HEALTH"] = "HEALTH";
    StoryType["GROWTH"] = "GROWTH";
    StoryType["DIET"] = "DIET";
    StoryType["NEWBORN_DIET"] = "NEWBORN_MEAL";
    StoryType["PUPPY_DIET"] = "PUPPY_DIET";
    StoryType["ADOLESCENCE_DIET"] = "ADOLESCENCE_DIET";
    StoryType["ADULT_DIET"] = "ADULT_DIET";
    StoryType["EXERCISE"] = "EXERCISE";
    StoryType["GROOMING"] = "GROOMING";
    StoryType["HAIR"] = "HAIR";
    StoryType["NAILS"] = "NAILS";
    StoryType["TEETH"] = "TEETH";
    StoryType["MEDICAL"] = "MEDICAL";
    StoryType["VETERINARY"] = "VETERINARY";
    StoryType["NEUTERING"] = "NEUTERING";
    StoryType["VACCINATIONS"] = "VACCINATIONS";
    StoryType["INSURANCE"] = "INSURANCE";
    StoryType["TRAINING"] = "TRAINING";
    StoryType["BEHAVIOR"] = "BEHAVIOR";
    StoryType["WALKING"] = "WALKING";
    StoryType["SOCIAL"] = "SOCIAL";
    StoryType["HOME"] = "HOME";
})(StoryType = exports.StoryType || (exports.StoryType = {}));
